import React from "react";

const Container = ({ children }) => {
  return <div className="content">{children}</div>;
};

export default Container;
